import { CancelButton, SaveButton } from '@core/components/Buttons';
import { TextInput } from '@core/components/Inputs';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { Grid, Typography } from '@material-ui/core';
import { cancelarAlert } from 'app/services/alerts';
import clsx from 'clsx';
import { FormikProvider, useFormik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import DreList from '../DreList';
import categoriaItemStyles from './styles';

const FormClasseEdit = ({ classe, dreList, onSuccess, onCancel, onSubmit }) => {
  const styles = categoriaItemStyles();
  // INFO: verifica se a classe É sintética (diferente da situação que PODE ser ou não sintética)
  const isSintetico = classe.classesFilhas && classe.classesFilhas.length > 0;

  const getInitialValues = (_classe) => ({
    nome: _classe.nome,
    dre: _classe.dreId,
  });

  const initialErrors = {
    nome: '',
    dre: '',
  };

  const categoriaSchema = Yup.object().shape({
    nome: Yup.string()
      .required(mensagemCampoObrigatorio('a descrição.'))
      .min(3, 'É necessário informar pelo menos 3 caracteres no campo'),
    dre: Yup.string().nullable(),
  });

  const handleCancel = () => {
    const close = () => {
      formik.resetForm(getInitialValues(classe));
      onCancel();
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const handleEdit = async (data) => {
    const _classe = {
      ...classe,
      nome: data.nome,
      dreId: data.dre,
    };

    if (!formik.dirty) {
      onSuccess();
    } else {
      const res = await onSubmit(_classe);

      if (res) {
        // mais performático que percorrer toda a árvore
        // SIDE EFFECT
        classe.nome = data.nome;
        classe.dreId = data.dre;
        // SIDE EFFECT END

        onSuccess();
      }
    }
  };

  const formik = useFormik({
    validationSchema: categoriaSchema,
    onSubmit: handleEdit,
    initialValues: getInitialValues(classe),
    initialErrors,
  });

  return (
    <FormikProvider value={formik}>
      <Typography
        variant="subtitle2"
        display="inline"
        className={`${styles.edicaoDeText} ${styles[`corner.edit.${classe.nivel + 1}`]}`}
      >
        {`Edição de ${classe.indice}`}
      </Typography>
      <form className={clsx(styles.form, `${styles[`corner.edit.${classe.nivel + 1}`]}`)}>
        <Grid container spacing={3} alignItems="center" justify="center">
          <Grid item xs={12} sm={12} md={4} xl={4} ls={4}>
            <TextInput
              id="nome"
              name="nome"
              required
              value={formik.values.nome}
              onChange={formik.handleChange}
              label="Descrição"
              variant="outlined"
              error={formik.errors.nome}
              autoFocus
              fullWidth
              maxLength={128}
              touched={!!formik.errors.nome}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} xl={4} ls={4}>
            {!isSintetico && (
              <DreList
                id="dre"
                name="dre"
                selecionado={formik.values.dre}
                onChange={formik.handleChange}
                dres={dreList}
              />
            )}
          </Grid>
          <Grid item md={4} />
        </Grid>
        <div className={styles.containerButtons}>
          <CancelButton onClick={handleCancel}>Cancelar</CancelButton>
          <SaveButton id={`btn-edit-${classe.id}`} onClick={formik.handleSubmit}>
            Salvar
          </SaveButton>
        </div>
      </form>
    </FormikProvider>
  );
};

export default FormClasseEdit;
